var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form', {
    ref: "ruleForm",
    attrs: {
      "model": _vm.from,
      "rules": _vm.rules,
      "label-width": "170px"
    }
  }, [_c('table', {
    staticStyle: {
      "width": "95%",
      "margin": "0 2%",
      "margin-top": "20px"
    }
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "height": "30px",
      "width": "25%"
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('template', {
    slot: "label"
  }, [_c('span', {
    staticStyle: {
      "text-align": "right",
      "color": "#a1a1a1",
      "line-height": "48px",
      "font-size": "16px"
    }
  }, [_vm._v("社保编号：")])]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请输入社保编号",
      "size": "small"
    },
    model: {
      value: (_vm.from.social_security_no),
      callback: function($$v) {
        _vm.$set(_vm.from, "social_security_no", $$v)
      },
      expression: "from.social_security_no"
    }
  })], 2)], 1), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "25%"
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('template', {
    slot: "label"
  }, [_c('span', {
    staticStyle: {
      "text-align": "right",
      "color": "#a1a1a1",
      "line-height": "48px",
      "font-size": "16px"
    }
  }, [_vm._v("医保编号：")])]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请输入医保编号",
      "size": "small"
    },
    model: {
      value: (_vm.from.medical_insurance_no),
      callback: function($$v) {
        _vm.$set(_vm.from, "medical_insurance_no", $$v)
      },
      expression: "from.medical_insurance_no"
    }
  })], 2)], 1), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "25%"
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('template', {
    slot: "label"
  }, [_c('span', {
    staticStyle: {
      "text-align": "right",
      "color": "#a1a1a1",
      "line-height": "48px",
      "font-size": "16px"
    }
  }, [_vm._v("保险类别：")])]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "multiple": "",
      "collapse-tags": "",
      "placeholder": "请选择保险类别",
      "size": "small",
      "clearable": ""
    },
    model: {
      value: (_vm.from.insurance_type_ids),
      callback: function($$v) {
        _vm.$set(_vm.from, "insurance_type_ids", $$v)
      },
      expression: "from.insurance_type_ids"
    }
  }, _vm._l((_vm.insuranceTypeList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.data,
        "value": item.id
      }
    })
  }), 1)], 2)], 1), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "25%"
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('template', {
    slot: "label"
  }, [_c('span', {
    staticStyle: {
      "text-align": "right",
      "color": "#a1a1a1",
      "line-height": "48px",
      "font-size": "16px"
    }
  }, [_vm._v("五险参保开始月份：")])]), _vm._v(" "), _c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "month",
      "placeholder": "请选择五险参保开始月份",
      "value-format": "yyyy-MM",
      "size": "small"
    },
    model: {
      value: (_vm.from.insured_begin_date),
      callback: function($$v) {
        _vm.$set(_vm.from, "insured_begin_date", $$v)
      },
      expression: "from.insured_begin_date"
    }
  })], 2)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "height": "30px"
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('template', {
    slot: "label"
  }, [_c('span', {
    staticStyle: {
      "text-align": "right",
      "color": "#a1a1a1",
      "line-height": "48px",
      "font-size": "16px"
    }
  }, [_vm._v("缴纳社保城市：")])]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择缴纳社保城市",
      "size": "small",
      "clearable": ""
    },
    model: {
      value: (_vm.from.insured_city),
      callback: function($$v) {
        _vm.$set(_vm.from, "insured_city", $$v)
      },
      expression: "from.insured_city"
    }
  }, _vm._l((_vm.$globals.cityList), function(item) {
    return _c('el-option', {
      key: item.city,
      attrs: {
        "label": item.city,
        "value": item.city
      }
    })
  }), 1)], 2)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('template', {
    slot: "label"
  }, [_c('span', {
    staticStyle: {
      "text-align": "right",
      "color": "#a1a1a1",
      "line-height": "48px",
      "font-size": "16px"
    }
  }, [_vm._v("缴费基数：")])]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "number",
      "placeholder": "请输入缴费基数",
      "size": "small"
    },
    model: {
      value: (_vm.from.payment_type),
      callback: function($$v) {
        _vm.$set(_vm.from, "payment_type", $$v)
      },
      expression: "from.payment_type"
    }
  })], 2)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('template', {
    slot: "label"
  }, [_c('span', {
    staticStyle: {
      "text-align": "right",
      "color": "#a1a1a1",
      "line-height": "48px",
      "font-size": "16px"
    }
  }, [_vm._v("雇主出险记录：")])]), _vm._v(" "), _c('el-button', {
    attrs: {
      "plain": "",
      "size": "mini"
    },
    on: {
      "click": _vm.dangerStatus
    }
  }, [_vm._v("出险记录")])], 2)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('template', {
    slot: "label"
  }, [_c('span', {
    staticStyle: {
      "text-align": "right",
      "color": "#a1a1a1",
      "line-height": "48px",
      "font-size": "16px"
    }
  }, [_vm._v("雇主出险状态：")])]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "size": "small",
      "disabled": ""
    },
    model: {
      value: (_vm.from.entry_type),
      callback: function($$v) {
        _vm.$set(_vm.from, "entry_type", $$v)
      },
      expression: "from.entry_type"
    }
  })], 2)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "height": "30px"
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('template', {
    slot: "label"
  }, [_c('span', {
    staticStyle: {
      "text-align": "right",
      "color": "#a1a1a1",
      "line-height": "48px",
      "font-size": "16px"
    }
  }, [_vm._v("是否缴纳公积金：")])]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.from.is_accumulation_fund),
      callback: function($$v) {
        _vm.$set(_vm.from, "is_accumulation_fund", $$v)
      },
      expression: "from.is_accumulation_fund"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "0"
    },
    model: {
      value: (_vm.from.is_accumulation_fund),
      callback: function($$v) {
        _vm.$set(_vm.from, "is_accumulation_fund", $$v)
      },
      expression: "from.is_accumulation_fund"
    }
  }, [_vm._v("否")])], 2)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('template', {
    slot: "label"
  }, [_c('span', {
    staticStyle: {
      "text-align": "right",
      "color": "#a1a1a1",
      "line-height": "48px",
      "font-size": "16px"
    }
  }, [_vm._v("公积金编号：")])]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请输入公积金编号",
      "size": "small"
    },
    model: {
      value: (_vm.from.accumulation_fund_no),
      callback: function($$v) {
        _vm.$set(_vm.from, "accumulation_fund_no", $$v)
      },
      expression: "from.accumulation_fund_no"
    }
  })], 2)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('template', {
    slot: "label"
  }, [_c('span', {
    staticStyle: {
      "text-align": "right",
      "color": "#a1a1a1",
      "line-height": "48px",
      "font-size": "16px"
    }
  }, [_vm._v("公积金基数：")])]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "number",
      "placeholder": "请输入公积金基数",
      "size": "small"
    },
    model: {
      value: (_vm.from.provident_fund_base),
      callback: function($$v) {
        _vm.$set(_vm.from, "provident_fund_base", $$v)
      },
      expression: "from.provident_fund_base"
    }
  })], 2)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('template', {
    slot: "label"
  }, [_c('span', {
    staticStyle: {
      "text-align": "right",
      "color": "#a1a1a1",
      "line-height": "48px",
      "font-size": "16px"
    }
  }, [_vm._v("缴纳账户：")])]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择缴纳账户",
      "size": "small",
      "clearable": ""
    },
    model: {
      value: (_vm.from.payment_account),
      callback: function($$v) {
        _vm.$set(_vm.from, "payment_account", $$v)
      },
      expression: "from.payment_account"
    }
  }, _vm._l((_vm.PartnerList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.partner_abbreviation,
        "value": item.id
      }
    })
  }), 1)], 2)], 1)]), _vm._v(" "), _c('tr', [_c('td', [_c('el-form-item', {
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('template', {
    slot: "label"
  }, [_c('span', {
    staticStyle: {
      "text-align": "right",
      "color": "#a1a1a1",
      "line-height": "48px",
      "font-size": "16px"
    }
  }, [_vm._v("五险缴纳账户：")])]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择五险缴纳账户",
      "size": "small",
      "clearable": ""
    },
    model: {
      value: (_vm.from.five_risks_account),
      callback: function($$v) {
        _vm.$set(_vm.from, "five_risks_account", $$v)
      },
      expression: "from.five_risks_account"
    }
  }, _vm._l((_vm.PartnerList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.partner_abbreviation,
        "value": item.id
      }
    })
  }), 1)], 2)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('template', {
    slot: "label"
  }, [_c('span', {
    staticStyle: {
      "text-align": "right",
      "color": "#a1a1a1",
      "line-height": "48px",
      "font-size": "16px"
    }
  }, [_vm._v("养老三险基数：")])]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "number",
      "placeholder": "请输入养老三险基数",
      "size": "small"
    },
    model: {
      value: (_vm.from.aged_three_insurance),
      callback: function($$v) {
        _vm.$set(_vm.from, "aged_three_insurance", $$v)
      },
      expression: "from.aged_three_insurance"
    }
  })], 2)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('template', {
    slot: "label"
  }, [_c('span', {
    staticStyle: {
      "text-align": "right",
      "color": "#a1a1a1",
      "line-height": "48px",
      "font-size": "16px"
    }
  }, [_vm._v("生育医疗保险基数：")])]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "number",
      "placeholder": "请输入生育医疗保险基数",
      "size": "small"
    },
    model: {
      value: (_vm.from.birth_insurance),
      callback: function($$v) {
        _vm.$set(_vm.from, "birth_insurance", $$v)
      },
      expression: "from.birth_insurance"
    }
  })], 2)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('template', {
    slot: "label"
  }, [_c('span', {
    staticStyle: {
      "text-align": "right",
      "color": "#a1a1a1",
      "line-height": "50px",
      "font-size": "16px"
    }
  }, [_vm._v("是否扣医保大额：")])]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择缴纳月是否扣医保大额",
      "size": "small",
      "clearable": ""
    },
    model: {
      value: (_vm.from.is_insurance_medical),
      callback: function($$v) {
        _vm.$set(_vm.from, "is_insurance_medical", $$v)
      },
      expression: "from.is_insurance_medical"
    }
  }, _vm._l((_vm.medicalLevel), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 2)], 1)]), _vm._v(" "), _c('tr', [_c('td', [_c('el-form-item', {
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('template', {
    slot: "label"
  }, [_c('span', {
    staticStyle: {
      "text-align": "right",
      "color": "#a1a1a1",
      "line-height": "48px",
      "font-size": "16px"
    }
  }, [_vm._v("五险补差数额：")])]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "number",
      "placeholder": "请输入五险补差数额",
      "size": "small"
    },
    model: {
      value: (_vm.from.amount_making_difference),
      callback: function($$v) {
        _vm.$set(_vm.from, "amount_making_difference", $$v)
      },
      expression: "from.amount_making_difference"
    }
  })], 2)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('template', {
    slot: "label"
  }, [_c('span', {
    staticStyle: {
      "text-align": "right",
      "color": "#a1a1a1",
      "line-height": "48px",
      "font-size": "16px"
    }
  }, [_vm._v("补差日期：")])]), _vm._v(" "), _c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "month",
      "placeholder": "请选择补差日期",
      "value-format": "yyyy-MM",
      "size": "small"
    },
    model: {
      value: (_vm.from.variance_makeup_date),
      callback: function($$v) {
        _vm.$set(_vm.from, "variance_makeup_date", $$v)
      },
      expression: "from.variance_makeup_date"
    }
  })], 2)], 1), _vm._v(" "), _c('td'), _vm._v(" "), _c('td')])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.出险记录,
      "visible": _vm.dangerStatusType,
      "width": "30%",
      "center": "true",
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dangerStatusType = $event
      }
    }
  }, [_c('el-table', {
    ref: "multipleTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "header-cell-style": {
        background: '#F0F0F0',
        color: '#000000'
      },
      "data": _vm.danger,
      "tooltip-effect": "dark",
      "height": "300"
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "width": "50"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope_1) {
        return [_vm._v(_vm._s(scope_1.$index + 1))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "danger_dete",
      "label": "出险时间",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "settlement_status",
      "label": "理赔情况",
      "align": "center"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "10px"
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "85px",
      "background-color": "#006E4B",
      "color": "#FFFFFF",
      "border": "1px solid #006E4B"
    },
    on: {
      "click": function($event) {
        return _vm.dangerSavesp()
      }
    }
  }, [_vm._v("关闭")])], 1)], 1)], 1)
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d07b2e5","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ygdagl/YgdaXx/tabsEdit/insurance.vue
// module id = null
// module chunks = 